import { Component, ElementRef, ViewChild } from '@angular/core';
import { UserConstantsService } from '../../../shared/userConstants/user-constants.service';
import { includes } from 'lodash';
import { Subscription, Subject } from 'rxjs';
import {
  jsonAllowedExtension
} from '../../../shared/constant';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { CommonHttpService } from 'src/app/shared/services/common-http/common-http.service';
import { DefaultLanguageId } from 'src/app/shared/constants';
import { UtilitiesService } from 'src/app/shared/services/utilities/utilities.service';
@Component({
    selector: 'app-import-export',
    templateUrl: './import-export.component.html',
    styleUrls: ['./import-export.component.scss'],
    standalone: false
})
export class ImportExportComponent {
  languageData: any;
  token: string;
  pageid: number;
  selectedFile: any;
  imageChangedEvent: any = '';
  imageName: any;
  observer: Subscription[] = [];
  jsonAllowedExtensions = jsonAllowedExtension;
  defaultLanguageId = DefaultLanguageId;
  formData: FormData = new FormData();
  errMessage: string;
  playbookId: number;
  companyId: number;
  sortBy: number;
  jsonUploaded = new Subject();
  constructor(
    private utilitiesService: UtilitiesService,
    private commonHttpService: CommonHttpService,
    private userConstantsService: UserConstantsService,
    private modalRef: BsModalRef
  ) { }
  @ViewChild('fileInputJson') fileInputJson: ElementRef;

  downloadJsonData(languageId: number, languageName: string) {
    // download checks
    this.utilitiesService.getAssetAzureUrl(
      `/api/Translation/ GetJsonFileForExportTranslation?playbookId=${this.playbookId}&companyId=${this.companyId}&languageId=${languageId}&pageId=${this.pageid}&sortBy=${this.sortBy}&languageName=${languageName}`,
    { isShowErrorMessage: true, message: 'Something went wrong while exporting your data.' });
  }
  close() {
    this.formData = new FormData();
    this.selectedFile = null;
    this.clearResource();
    this.modalRef.hide();
  }
  save() {
    if (this.selectedFile) {
      this.observer.push(this.commonHttpService.postWithProgress({
        uri: `/api/Translation/SaveImportedJsonFileForTranslation?companyId=${this.companyId}&languageId=${this.languageData.id}&playbookId=${this.playbookId}`,
        object: this.formData,
        message: {
          showMessage: true,
          errorMessage: 'Something went wrong please try again',
          successMessage: `Data Successfully imported to the ${this.languageData.name} language.`
        }
      }).subscribe(response => {
        if (typeof response !== 'number' && response) {
          this.userConstantsService.setActivateWhichPage(this.pageid);
          this.jsonUploaded.next(true);
          this.close();
        }
      }));
    } else {
      this.errMessage = 'Please upload a file to save the data.';
    }
  }
  checkExtensionFunction(extensionAllowedArray) {
    let checkExtension;
    let extension;
    let extensionArray;
    extensionArray = this.selectedFile.name.split('.');
    extension = extensionArray[extensionArray.length - 1].toLowerCase();
    checkExtension = includes(extensionAllowedArray, extension);
    return checkExtension;
  }
  fileChangeEvent(event: any, extensionAllowedArray: Array<any>): void {
    let checkExtension;
    let extensionErrorMessage;
    let isAre;
    if (event.target.files[0] !== undefined) {
      this.selectedFile = event.target.files[0];
      this.imageChangedEvent = event;
      this.imageName = event.target.files[0].name;

      checkExtension = this.checkExtensionFunction(extensionAllowedArray);
      if (checkExtension) {
        this.upload();
      } else {
        this.selectedFile = null;
        this.imageChangedEvent = null;
        this.imageName = null;
        this.clearResource();
        isAre = extensionAllowedArray.length > 1 ? 'are' : 'is';
        extensionErrorMessage = 'This is not a valid extension. Supported extensions '
          + isAre + ' : ' + extensionAllowedArray.join(',') + '.';
        alert(extensionErrorMessage);
      }
    }
  }
  upload() {
    this.formData = new FormData();
    this.formData.append('jsonFile', this.selectedFile);
  }
  clearResource() {
    if (this.fileInputJson) {
      this.fileInputJson.nativeElement.value = null;
    }
  }
}
